/**
 * @license
 * Copyright (c) 2018 Google Inc. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * Code distributed by Google as part of this project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
'use strict';

import DevtoolsChannel from '../../platform/devtools-channel-web.js';

let instance = null;
export default {
  get: () => {
    if (!instance) instance = new DevtoolsChannel();
    return instance;
  }
};



//////////////////
// WEBPACK FOOTER
// /Users/sjmiles/Sites/projects/arcs/arcs/runtime/debug/devtools-channel-provider.js
// module id = 53
// module chunks = 0